export default {
    borderRadiusXs: 2,
    borderRadiusSm: 4,
    borderRadiusMd: 6,
    borderRadiusLg: 8,
    borderRadiusXl: 10,
}